var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shell-loading"},[_c('div',{staticClass:"spinner",attrs:{"aria-hidden":"true"}}),_c('h2',[_vm._v("Loading")]),_c('p',[_vm._v("Preparing workspace...")])])
}]

export { render, staticRenderFns }